export const SET_CLAIM_CODE = 'SET_CLAIM_CODE';
